import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsComponentBorder from "../components/CmsComponentBorder.js";
import CmsBlockFaqItem from "./CmsBlockFaqItem.js";

export default class CmsBlockFaqList extends CmsBlock {
    static typeDef = {
        name: `FAQ|FAQ`,
        glyph: `fa-messages-question`,
        type: `faq-list`,
        category: `layout`,
        isParent: true
    }

    get childClasses() {
        return [CmsBlockFaqItem];
    }

    get maxChildren() {
        return 20;
    }

    constructor(data, page) {
        super(data, page);

        this.divider = new CmsComponentBorder(this.divider);

        if (!data) {
            this.spacing = `10px`;

            const template = new CmsBlockFaqItem();
            this.addChild(template);
            this.addChild(new CmsBlockFaqItem());

            this.enableTemplate = true;
            this.templateItemId = template.id;
            this.updateTemplateItem();
        }
    }
}
